var map = {
	"./amex.png": 877,
	"./diners.png": 878,
	"./discover.png": 879,
	"./jcb.png": 880,
	"./maestro.png": 1103,
	"./mastercard.png": 881,
	"./stripe.png": 882,
	"./union.png": 883,
	"./unknown.png": 567,
	"./visa.png": 884
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1102;